const CONFIG = process.env.CONFIG

const WidgetInstallScript = ({ EMBED_TOKEN }) => {
  return `<!--Start of Bot Widget Install Script-->
      <script>
        window.HFBOT_CONFIG = {
          EMBED_TOKEN: "${EMBED_TOKEN}",
          options: {
            showBadge: true
          }
        }
        ;(function () {
        const scriptTag = document.createElement('script')
        scriptTag.type = 'text/javascript'
        scriptTag.async = true
        scriptTag.defer = true
        scriptTag.src = "${new URL('/js/widget-loader.js', CONFIG.WIDGET_ASSET_URL).href}"
        var e = document.body || document.head
        e.appendChild(scriptTag)
        })()
      </script>
  <!--End of Bot Widget Install Script-->`
}

export default WidgetInstallScript
